import React from 'react';
import { cn } from '@/utils/cn';

const SubstitutionItemSkeleton = ({ reverse = false }: { reverse?: boolean }) => {
  return (
    <li className={cn('flex items-center gap-2', reverse ? 'flex-row-reverse' : '')}>
      <div className="w-[28px] h-[28px] sm:w-[32px] sm:h-[32px] dark:bg-gray-600 bg-gray-200 rounded-full animate-pulse" />
      <div className="space-y-1 sm:space-y-1.5">
        <div className={cn('flex items-center gap-2', reverse ? 'flex-row-reverse' : '')}>
          <div className="h-2 sm:h-3 w-16 sm:w-20 dark:bg-gray-600 bg-gray-200 rounded animate-pulse" />
          <div className="h-2 sm:h-3 w-8 sm:w-10 dark:bg-gray-600 bg-gray-200 rounded animate-pulse" />
        </div>
        <div className={cn('flex items-center gap-1', reverse ? 'flex-row-reverse' : '')}>
          <div className="w-3 h-2 sm:w-4 sm:h-3 dark:bg-gray-600 bg-gray-200 rounded animate-pulse" />
          <div className="h-2 sm:h-3 w-12 sm:w-16 dark:bg-gray-600 bg-gray-200 rounded animate-pulse" />
          <div className="h-4 sm:h-5 w-6 sm:w-8 dark:bg-gray-600 bg-gray-200 rounded border dark:border-border-400 border-gray-200 animate-pulse" />
        </div>
      </div>
    </li>
  );
};

const SubstitutionsSkeleton = () => {
  return (
    <div className="flex justify-between dark:bg-black-400 bg-white_theme-50 rounded-md mt-2 px-2 py-3">
      <div>
        <div className="h-3 sm:h-4 w-24 sm:w-32 dark:bg-gray-600 bg-gray-200 rounded animate-pulse mb-2" />
        <ul className="space-y-3 pl-0">
          {Array.from({ length: 2 }).map((_, index) => (
            <SubstitutionItemSkeleton key={`home-${index}`} />
          ))}
        </ul>
      </div>
      <div className="flex flex-col items-end">
        <div className="h-3 sm:h-4 w-24 sm:w-32 dark:bg-gray-600 bg-gray-200 rounded animate-pulse mb-2" />
        <ul className="flex flex-col items-end space-y-3 pl-0">
          {Array.from({ length: 2 }).map((_, index) => (
            <SubstitutionItemSkeleton key={`away-${index}`} reverse />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SubstitutionsSkeleton;
